export default __webpack_public_path__ + "static/media/Mishustin_Mikhail.1940826e.webp";